import { useLazyQuery } from '@apollo/client';
import { QUERY_MY_VERIFY_DETAILS } from '../../graphql/user-queries';

export default function useGetMyVerifyDetails() {
    const [getMyVerifyDetails, { data, loading, error }] = useLazyQuery(QUERY_MY_VERIFY_DETAILS);
    return { getMyVerifyDetails, userDetails: data && data.me, loading, error };
}
